const Skeleton = ({ className = '' }) => {
    return (
        <div className={`bg-platinum animate-pulse ${className}`} />
    );
};

export default Skeleton;
